import { withStyles }  from '@mui/styles';
import Button from '@mui/material/Button';
import green from '@mui/material/colors/green';


const Green_Button = withStyles((theme) => ({
    root: {
        color: theme.palette.getContrastText(green[500]),
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },
}))(Button);


const GPAP_Button  = withStyles((theme) => ({
    root: {
        color: "white",
        backgroundColor: "#4575B4",
        '&:hover': {
            backgroundColor: "#91BFDB",
        },
    },
}))(Button);

const GPAP_Button_light  = withStyles((theme) => ({
    root: {
        color: "#4575B4",
        backgroundColor: "#FAFAFA",
        '&:hover': {
            backgroundColor: "#f0f0f0",
        },
    },
}))(Button);

const GPAP_Button_Orange  = withStyles((theme) => ({
    root: {
        color: "white",
        backgroundColor: "orange",
        '&:hover': {
            backgroundColor: "#e6550d",
            color: "black"
        },
    },
}))(Button);

const OrangeTextButton = withStyles((theme) => ({
    root: {
        color: "orange"
    },
}))(Button);


export default GPAP_Button
export { Green_Button, GPAP_Button_light,GPAP_Button_Orange, OrangeTextButton };